import { Layout } from "../../../../../s25-object-search/s25.object.search.util";
import { rsrvType, S25RmReservation } from "../../../../ReservationI";
import { S25Util } from "../../../../../../util/s25-util";

type LocationSearchInput = Partial<S25RmReservation> & { layouts?: Layout[] };

export type OccurrenceDeleteWarning = {
    index: number | null;
    msg: string | null;
    listItems: unknown;
    objType: "space" | "resource" | null;
    rsrvType: rsrvType | "waitlist" | null;
};

export const emptyOccurrenceDeleteWarning = (): OccurrenceDeleteWarning => ({
    index: null,
    msg: null,
    listItems: null,
    objType: null,
    rsrvType: null,
});

export function resolveLocationDisplayCapacity(
    maxCapacity: number | undefined,
    layouts: Layout[] | undefined,
): number | undefined {
    let capacity = maxCapacity;
    if (layouts?.length) {
        const defaultLayout = S25Util.propertyGetParentWithChildValue(layouts, "default_layout", "T") as Layout | null;
        const layoutCapacity = defaultLayout?.layout_capacity;
        if (layoutCapacity != null && layoutCapacity > 0) {
            capacity = layoutCapacity;
        }
    }
    return capacity;
}

export function normalizeLocationFromObjectSearch(location: LocationSearchInput): S25RmReservation {
    const locationLayout = location.locationLayout ?? location.layouts ?? [];
    const defaultLayout =
        (S25Util.propertyGetParentWithChildValue(locationLayout, "default_layout", "T") as Layout | null) ??
        locationLayout[0];
    const displayCapacity = resolveLocationDisplayCapacity(location.maxCapacity ?? undefined, locationLayout);
    const roomCapacity = location.maxCapacity ?? displayCapacity ?? location.layout?.roomCapacity;

    return {
        ...location,
        locationLayout,
        layout: {
            itemId: location.layout?.itemId ?? defaultLayout?.layout_id ?? 0,
            itemName: location.layout?.itemName ?? defaultLayout?.layout_name ?? "",
            capacity: displayCapacity ?? location.layout?.capacity ?? roomCapacity ?? 0,
            roomCapacity: roomCapacity ?? location.layout?.roomCapacity ?? displayCapacity ?? 0,
        },
        maxCapacity: location.maxCapacity ?? roomCapacity,
    } as S25RmReservation;
}

export function locationDefaultCapacity(location: S25RmReservation): number | undefined {
    const searchLayouts = (location as LocationSearchInput).layouts;
    const layouts = location.locationLayout ?? searchLayouts;
    const resolved = resolveLocationDisplayCapacity(location.maxCapacity ?? undefined, layouts ?? undefined);
    if (resolved != null) {
        return resolved;
    }

    const fromLayout = location.layout?.capacity ?? location.layout?.roomCapacity;
    if (fromLayout != null) {
        return fromLayout;
    }

    return location.maxCapacity ?? undefined;
}

/** Layout dropdown: name plus capacity in parentheses (matches location / event form context). */
export function layoutSelectOptionLabel(layout: Layout): string {
    const name = layout.layout_name?.trim() ?? "";
    const cap = layout.layout_capacity;
    if (cap !== undefined && cap !== null) {
        return `${name} (${cap})`;
    }
    return name;
}
